import { useQuery } from 'react-query';
import { KeyResolver } from '../KeyResolver';
const keyFetcher = async (key, infraApiUrl) => {
  if (!key) {
    throw new Error('no key provided');
  }
  const keyResolver = new KeyResolver(infraApiUrl);
  return await keyResolver.get(key);
};
let infraApiUrlRef = '';
const useFetchSecret = key => {
  return useQuery(key !== '' && [key, infraApiUrlRef], keyFetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });
};
export const useSecret = infraApiUrl => {
  infraApiUrlRef = infraApiUrl !== null && infraApiUrl !== void 0 ? infraApiUrl : '';
  return useFetchSecret;
};